import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { useGestaoTreinamentosListaViewModel } from "../../viewModels/gestao_treinamentos_lista_view_model";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import { useMemo } from "react";
import { GenerateColumnsDefinition } from "./columns";
import { LegendaModal } from "./components/legenda_modal";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";

/**
 * GestaoTreinamentosLista
 */

export const GestaoTreinamentosLista = () => {
  const viewModel = useGestaoTreinamentosListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateColumnsDefinition({
      onActionEdit: viewModel.handleGestaoTreinamentosCadastroOpenState,
    });
  }, [
    viewModel.handleGestaoTreinamentosCadastroOpenState,
  ]);

  return (
    <>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            RH
          </Link>
          <Typography className="text-primary-green">
            Gestão de Treinamentos
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Gestão de Treinamentos</h1>
            <RefreshButton onClick={() => { }} />
          </div>
        </div>

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReloadPage} />
              </div>
            ) : (
              <>
                <Header
                  tipoPesquisa={viewModel.filters.tipoPesquisa}
                  pesquisa={viewModel.filters.pesquisa}
                  setor={viewModel.filters.setor}
                  filial={viewModel.filters.filial}
                  admissaoDe={viewModel.filters.admissaoDe}
                  admissaoAte={viewModel.filters.admissaoAte}
                  demissaoDe={viewModel.filters.demissaoDe}
                  demissaoAte={viewModel.filters.demissaoAte}
                  afastamentoDe={viewModel.filters.afastamentoDe}
                  afastamentoAte={viewModel.filters.afastamentoAte}
                  feriasDe={viewModel.filters.feriasDe}
                  feriasAte={viewModel.filters.feriasAte}
                  treinamento={viewModel.filters.treinamentos}
                  prazoExperiencia={viewModel.filters.prazoExperiencia}
                  documento={viewModel.filters.documentos}
                  centroDeCusto={viewModel.filters.centroDeCusto}
                  status={viewModel.filters.status}
                  centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
                  handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
                  handlePesquisa={viewModel.handlePesquisaChange}
                  handleSetor={viewModel.handleSetorChange}
                  handleFilial={viewModel.handleFilialChange}
                  handleAdmissao={viewModel.handleAdmissaoChange}
                  handleDemissao={viewModel.handleDemissaoChange}
                  handleAfastamento={viewModel.handleAfastamentoChange}
                  handleFerias={viewModel.handleFeriasChange}
                  handleTreinamento={viewModel.handleTreinamento}
                  handlePrazoExperiencia={viewModel.handlePrazoExperiencia}
                  handleDocumento={viewModel.handleDocumento}
                  handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
                  handleStatusSelection={viewModel.handleStatusChange}
                  handleClearFilters={viewModel.handleClearFilters} />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-end">
                    <div className="flex flex-col justify-end my-2">
                      <span
                        className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
                        onClick={() => viewModel.handleShowLegenda(true)}>
                        Legenda
                      </span>
                    </div>


                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.funcionarios.totalItems}
                        page={viewModel.pagination.funcionarios.page - 1}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        rowsPerPage={viewModel.pagination.funcionarios.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>
                  </div>

                  <StyledDataGrid
                    tableName="gestao_treinamentos_lista"
                    textSize="pequeno"
                    disableColumnMenu={false}
                    getRowId={(row) => row.idFuncionario}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.funcionarios}
                    rowCount={viewModel.funcionarios.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.funcionarios.page,
                      pageSize: viewModel.pagination.funcionarios.rowsPerPage,
                    }} />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.funcionarios.totalItems}
                    page={viewModel.pagination.funcionarios.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.funcionarios.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }

        {/**
          * Modals
          */}

        <LegendaModal
          open={viewModel.showLegenda}
          onClose={() => viewModel.handleShowLegenda(false)}
        />

      </div>
    </>
  )
}